<script setup lang="ts">
import UiModal from '@boats/ui/components/UiModal.vue'

const modals = useModalsStore()

const register = () => {
  modals.openRegisterModal()
  modals.closeLoginModal()
}
</script>

<template>
  <UiModal
    v-model="modals.isLoginModalOpen"
    mobile-full-screen
    class="app-modal-login"
    @close="modals.closeLoginModal"
  >
    <h2 class="h1 mb-2">{{ $t('modal.login.title') }}</h2>

    <p class="mb-5 md:mb-8">
      {{ $t('modal.login.register.text') }}
      <a role="button" @click="register">
        {{ $t('string.Register') }}
      </a>
    </p>

    <AppFormLogin />

    <div class="text-button my-6">{{ $t('string.or') }}</div>

    <AppButton variant="outlined" full-width @click="modals.closeLoginModal">
      {{ $t('modal.login.continue-button') }}
    </AppButton>
  </UiModal>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-modal-login {
  .ui-modal__content {
    text-align: center;

    @include media-breakpoint-up(md) {
      h2 {
        font-size: 2.625rem;
        font-weight: 400;
        line-height: 1;
      }
    }
  }
}
</style>
